import {Typography} from '@sollapay/ui/components';

import type {FC, ReactNode} from 'react';

export interface SidebarSectionLabelProps {
  children: ReactNode;
}

export const SidebarSectionLabel: FC<SidebarSectionLabelProps> = ({children}) => (
  <div className="pt-1.5 pb-1 px-3">
    <Typography size="xs" weight="semibold" color="tertiary">
      {children}
    </Typography>
  </div>
);
